import React, { FC } from 'react'
import styles from './Documents.module.scss'
import { DocumentsProps } from './Documents.model'

export const Documents: FC<DocumentsProps> = ({ children }) => (
  <div className={styles.container}>{children}</div>
)
